import { PaginationAdapter } from '@red/data-access';
import { createAction, props } from '@ngrx/store';
import { PaymentModel } from '@shared/data-access/models';
import { IQuerySearch } from '@shared/data-access/interfaces';
// items
export const loadItems = createAction('[Payment] Load items', props<{ filters: IQuerySearch }>());
export const loadItemsSuccess = createAction('[Payment] Load items success', props<{ data: PaginationAdapter<PaymentModel> }>());

// item
export const loadItem = createAction('[Payment] Load item', props<{ id: number }>());
export const loadItemSuccess = createAction('[Payment] Load item success', props<{ item: PaymentModel }>());
